export default "__VITE_ASSET__BW$NHh2w__"